module.exports = __webpack_public_path__ + "static/img/weixin.1e06a3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.png
// module id = AVav
// module chunks = 1